<div class="header">
  <h1>{{dateTime | async | date:'h:mm'}}</h1>
<h2>{{dateTime |async | date:'d MMMM y'}}</h2>
</div>
